<template>
  <div :style="{ width, height }">
    <component class="icon" :is="props.src" :width="width" :height="height"></component>
  </div>
</template>
<script setup lang="ts">
import { type Component } from 'vue'

const props = withDefaults(
  defineProps<{
    src: Component
    width: string
    height: string
    top?: string
  }>(),
  {
    top: '0',
  },
)
</script>
<style>
.icon {
  width: v-bind(width);
  height: v-bind(height);
  left: 0;
  top: v-bind(top);
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
  display: inline-flex;
  position: relative;
}
svg {
  width: v-bind(width);
  height: v-bind(height);
}
</style>
